<template>
   <div class="container">
       <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
        >
        Amazing! We will read your message and get back to you soon! Wait here for {{ dismissCountDown }} seconds...
        </b-alert>
        <form @submit.prevent="sendEmail">
          <label>Name</label>
          <input 
            type="text" 
            v-model="inputName"
            name="name"
            placeholder="Your Name"
          >
          <label>Email</label>
          <input 
            type="email" 
            v-model="inputEmail"
            name="email"
            placeholder="Your Email"
            >
          <label>Message</label>
          <textarea 
            name="message"
            v-model="inputBody"
            cols="30" rows="5"
            placeholder="Message">
          </textarea>
          
          <input type="submit" value="Send">
        </form>
    </div>
</template>

<script>

import Button from '../components/Button.vue';
import emailjs from 'emailjs-com';
import{ init } from 'emailjs-com';

export default {
    components: { 
        [Button.name]: Button, 
        
    },
    props: {
    
    },
    data() {
        return {
            inputName: "",
            inputBody: "",
            inputEmail: "",
            dismissSecs: 10,
            dismissCountDown: 0           
        }
    },
    methods: {
        sendEmail(e) {                        
            try {
                emailjs.sendForm('service_6at2fyr', 'template_prlg3dn', e.target,
                    'user_sbJtcXZoJqPUt4HY9tRGf', {
                        name: this.inputName,
                        email: this.inputEmail,                        
                        message: this.inputBody                        
                    })
            } catch (error) {
                // console.log({error})
            }
            // Reset form field
            this.inputName = ''
            this.inputEmail = ''
            this.inputBody = ''
            this.showAlert();
        },
        showAlert() {            
            this.dismissCountDown = this.dismissSecs;            
        },
        countDownChanged(dismissCountDown) {            
            this.dismissCountDown = dismissCountDown;            
            if (dismissCountDown == 0) {                
                this.$router.push({ name: "landing"})
            }
        },
        onSubmit(event) {
            event.preventDefault()
            alert(JSON.stringify(this.form))
        },
        onReset(event) {
            event.preventDefault()
            // Reset our form values
            this.form.email = ''
            this.form.name = ''
            this.form.food = null
            this.form.checked = []
            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
            this.show = true
            })
        }
    }

}
</script>

<style scoped>
* {box-sizing: border-box;}
label {
  float: left;
}
input[type=text], [type=email], textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}
input[type=submit] {
  background-color: #4CAF50;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
input[type=submit]:hover {
  background-color: #b8c7b9;
}
.container {    
  display: block;
  margin:auto;
  text-align: center;
  border-radius: 5px;
  background-color: #f2f2f2;
  padding: 20px;
  width: 90%;
}
</style>